"use client";

import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  number: "01",
  title: "PREMIUM TUBE AMPS",
  description: "A curated selection of vintage and modern tube heads and cabs, from classic British crunch to high-gain American roar.",
  tier: "BACKLINE"
}, {
  number: "02",
  title: "PRO DRUM KITS",
  description: "Studio-grade shells and hardware including Ludwig and Gretsch kits, tuned and ready for high-impact tracking sessions.",
  tier: "BACKLINE"
}, {
  number: "03",
  title: "LIVE TRACKING RIGS",
  description: "Multi-channel recording setups designed to capture the raw energy of a full band performance in real-time.",
  tier: "STUDIO"
}, {
  number: "04",
  title: "REHEARSAL SPACES",
  description: "Acoustically treated rooms equipped with high-headroom PA systems and professional monitoring for loud sessions.",
  tier: "STUDIO"
}, {
  number: "05",
  title: "VINTAGE SYNTH STACK",
  description: "Access to our collection of analog synthesizers and outboard gear for adding texture and grit to your sound.",
  tier: "ADD-ON"
}, {
  number: "06",
  title: "ENGINEERED SESSIONS",
  description: "Work with our in-house staff to dial in your tones and manage the technical side of your recording project.",
  tier: "BY ENQUIRY"
}];
export default function TheFullBackline() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const ledger = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  return <section data-section-id="5199" id="the-full-backline" className="bg-background text-foreground pt-40 md:pt-60 pb-24 md:pb-40 px-6 md:px-12 lg:px-16 overflow-hidden">
      <div className="max-w-[1600px] mx-auto">
        {}
        <div ref={header.ref} className={`mb-12 md:mb-16 transition-all duration-700 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-mono text-xs md:text-sm tracking-[0.2em] text-primary uppercase">
            — THE_ARSENAL / INDEX
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-20 md:mb-28">
          <div className="lg:col-span-8">
            <h1 className={`font-default font-extrabold uppercase leading-[0.9] tracking-tighter text-foreground transition-all duration-1000 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            fontSize: "clamp(3.5rem, 11vw, 13rem)"
          }}>
              <span className="inline-block text-transparent" style={{
              WebkitTextStroke: "1px var(--primary)"
            }}>
                T
              </span>
              HE FULL
              <br />
              BACKLINE
              <br />
              AMENITIES.
            </h1>
          </div>

          <div className="lg:col-span-4 flex lg:items-end">
            <p className={`font-default italic text-muted-foreground text-lg md:text-xl leading-relaxed max-w-[380px] transition-all duration-1000 delay-200 ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              At The Garage Room, we don&apos;t do generic. Every amp, every kit, and every cable is selected for its ability to deliver raw, unadulterated sonic power.
            </p>
          </div>
        </div>

        {}
        <div ref={ledger.ref} className="border-t border-border">
          {services.map((service, i) => <div data-index={i} key={service.number} className={`group relative grid grid-cols-12 gap-4 md:gap-6 items-start md:items-center py-8 md:py-0 md:h-[120px] border-b border-border px-2 md:px-4 transition-all duration-700 hover:bg-card cursor-pointer ${ledger.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: ledger.isVisible ? `${i * 80}ms` : "0ms"
        }}>
              {}
              <div className="col-span-2 md:col-span-1">
                <span className="font-mono text-xs md:text-sm text-primary tracking-wider">
                  {service.number}
                </span>
              </div>

              {}
              <div className="col-span-10 md:col-span-5 transition-transform duration-0 group-hover:translate-x-2">
                <h3 className="font-default font-bold uppercase text-foreground text-xl md:text-3xl lg:text-[36px] leading-tight tracking-tight">
                  {service.title}
                </h3>
              </div>

              {}
              <div className="col-span-12 md:col-span-4 col-start-3 md:col-start-auto">
                <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </p>
              </div>

              {}
              <div className="col-span-12 md:col-span-2 col-start-3 md:col-start-auto flex items-center justify-start md:justify-end gap-3">
                <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-primary border border-primary px-2 py-0.5">
                  {service.tier}
                </span>
                <ArrowRight className="size-4 text-primary transition-all duration-0 group-hover:translate-x-2" aria-hidden="true" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}